<template functional>
    <div
        class="VChangableLabel noselect"
        :class="`VChangableLabel_${props.action}`"
        @click="listeners.click($event)"
        v-on="listeners.mouseover ? { mouseover: listeners.mouseover } : null"
    >
        <span class="VChangableLabel__text">
        <slot></slot>
            </span>
        
        <div class="VChangableLabel__counter" >
            <slot name="prefix"></slot>{{ props.counter }}<slot name="postfix"></slot>
        </div>
        <div class="VChangableLabel__small-counter" v-if="props.smallCounter">
            {{ props.smallCounter }}
        </div>
        <span
            class="VChangableLabel__changes"
            v-if="props.changes"
            :class="props.changes >= 0 ? 'VChangableLabel__changes_positive' :  'VChangableLabel__changes_negative'"
        > ({{ (props.changes >= 0) ? '+' : '-' }}{{ Math.abs(props.changes) }})</span>
    </div>
</template>

<script>
    export default {
        name: 'VChangableLabel',
        props: {
            action: {
                type: String,
                default: 'remove',
                validator: function (value) {
                    return ['add', 'remove'].includes(value);
                },
            },
            counter: {
                type: [Number, String],
                required: true,
            },
            smallCounter: {
                type: [Number, String],
                required: false,
            },
            changes: {
                type: Number,
                required: false,
            },
            
        },
        
    };
</script>

<style
    scoped
    lang="scss"
>
    .VChangableLabel {
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
        display: flex;
        padding-right: 5px;
        align-items: center;
        position: relative;
        
        &__text{
            pointer-events: none;
        }
        &__counter {
            padding-left: 5px;
            font-weight: bold;
            display: flex;
            align-items: center;
            pointer-events: none;
        }
        
        &__small-counter {
            padding-left: 5px;
            font-weight: bold;
            display: flex;
            align-items: center;
            pointer-events: none;
            position: absolute;
            top: 12px;
            font-size: 9px;
            right: 13px;
        }
        
        &__changes {
            font-weight: bold;
            
            &_positive {
                color: $secondary-color;
            }
            
            &_negative {
                color: $negative-color;
            }
        }
    }
    
    .remove {
        transform: translate(0px, 5px) rotate(45deg);
    }
    
    .add {
        transform: translate(0px, 5px);
    }
</style>
